import React from 'react';

export const RadioAnswerField = ({
	options,
	fieldValue = null,
	onAnswerChange
}) => {
	
	return (
		<div>
		{	
			options.length > 0 && options.map((opt) => (
				<div className="form-check" key={opt.id}>
					<input className="form-check-input"
						type="radio"
						value={opt.id}
						checked={fieldValue === opt.id}
						onChange={(e) => onAnswerChange(e.target.value)} />
					<label className="form-check-label" htmlFor={opt.id} >
					{opt.name}
					</label>
				</div>
			))
		}
		</div>
	);
};

export default RadioAnswerField;
